import Radium from 'radium';

import { defaultPaddingLeft, mobileDefaultPadding, defaultPaddingTop } from 'constants/sizes';
import Device from 'constants/deviceSizes';

const containerBox = {
  width: '100%',
  boxSizing: 'border-box',
  padding: `${defaultPaddingTop}px ${defaultPaddingLeft}px`,
  [Device.desktop_tablet]: {
    width: '50%',
    paddingBottom: 0
  },
  [Device.mobile]: {
    padding: mobileDefaultPadding
  },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left'
};

const pulseAnimation = Radium.keyframes(
  {
    '6.5%': { transform: 'scale3d(1, 1, 1)' },
    '10%': { transform: 'scale3d(1.015, 1.015, 1.015)' },
    '13.5%': { transform: 'scale3d(1, 1, 1)' },
    '100%': { transform: 'scale3d(1, 1, 1)' }
  },
  'pulseAnimation'
);

export default {
  container: {
    ...containerBox
  },
  withLoading: {
    ...containerBox,
    [Device.desktop_tablet]: {
      width: '100%'
    },
    alignItems: 'center'
  },
  bannerContainer: {
    maxWidth: 630,
    margin: `15px ${defaultPaddingLeft}px 15px ${defaultPaddingLeft}px`,
    boxShadow: 'rgb(109, 123, 152) 5px 6px 20px 0px',
    animationName: pulseAnimation,
    animationFillMode: 'both',
    animationTimingFunction: 'cubic-bezier(0.03, -0.02, 0.75, 2.11)',
    animationDuration: '6s',
    animationDelay: '1s',
    animationIterationCount: 'infinite',
    [Device.mobile]: {
      animationName: 'none',
      margin: '0px 0px 10px 0px'
    }
  }
};
